import React from 'react'
import { Box, ThemeProvider, Typography } from '@mui/material'
import { t } from 'i18next'
import NewRsmLogo from '../media/NewRsmLogo'
import Footer from '../layouts/Footer'
import tokens from '../../styles/tokens.json'
import { normalTheme } from '../../styles/materialTheme'
import { Styles } from '../../types'

const styles: Styles = {
  unsubscribeContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  Heading: {
    backgroundColor: tokens.colors.white,
    paddingTop: '2.5rem',
    paddingBottom: '2.5rem',
    paddingLeft: '7.25rem',
    paddingRight: '7.25rem',
  },
  toolbarContainer: (theme) => ({
    height: 'fit-content',
    backgroundColor: tokens.colors.black,
    backgroundImage: `url(${process.env.PUBLIC_URL}/myRSMHeaderBackground.svg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.only('tablet')]: {
      paddingLeft: '2rem',
      paddingRight: '2rem',
    },
    [theme.breakpoints.up('desktop')]: {
      paddingLeft: '6.5rem',
      paddingRight: '6.5rem',
    },
  }),
  toolbarRedesign: {
    display: 'flex',
    height: '5.4375rem',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  homeIcon: {
    position: 'absolute',
    left: 0,
  },
  mainContainer: (theme) => ({
    backgroundColor: theme.palette.rsmBackground.main,
    flex: 1,
  }),
  successMessage: {
    padding: '3rem 1rem',
    fontWeight: 300,
    textAlign: 'center',
    fontSize: '3rem',
    lineHeight: '3.5rem',
  },
}

const UnsubscribeSuccess = () => (
  <ThemeProvider theme={normalTheme}>
    <Box sx={styles.unsubscribeContainer}>
      <Box sx={styles.mainContainer}>
        <Box sx={styles.toolbarContainer}>
          <Box sx={styles.toolbarRedesign}>
            <Box sx={styles.homeIcon}>
              <NewRsmLogo titleDescription="myRSM home" />
            </Box>
          </Box>
        </Box>

        <Box>
          <Typography variant="h5" sx={styles.successMessage}>
            {t('Unsubscribe.SuccessMessage')}
          </Typography>
        </Box>
      </Box>

      <Footer />
    </Box>
  </ThemeProvider>
)

export default UnsubscribeSuccess
